<div class="container-xl">
  <div class="row">
    <div class="co-12"><h1>{{title}}</h1>
    <p>Simple demo of heatmap component v2.2.0</p>
    </div>
  </div>
  <div class="row">
    <div class="col-2">&nbsp;</div>
    <div class="col-8">
      <label>size</label><input [(ngModel)]="size">
      <br/>
      <label>lastX</label><input [(ngModel)]="lastX">
      <br/>
      <label>gaps</label><input type="checkbox" [(ngModel)]="gaps">
      <br/>
      <label>normalized</label><input type="checkbox" [(ngModel)]="normalized">
      <br/>
      <label>middle zero</label><input type="checkbox" [(ngModel)]="middleZero">
      <br/>
      <button (click)="generate()">Generate</button>
      <br/>
      {{message()}}
      <br/>

      <!-- trying to reproduce freeze problems with material and heatmap in biodare, but cannot
      <mat-form-field>
        <mat-label>Select an option</mat-label>
        <mat-select [(value)]="size">
          <mat-option *ngFor="let val of sizes" [value]="val">{{val}}</mat-option>
        </mat-select>
      </mat-form-field>

      <br/>
      <mat-paginator #dataPaginator [length]="10000"
                     [pageSize]="size"
                     [pageIndex]="pageIndex"
                     [pageSizeOptions]="sizes"
                     (page)="loadDataPage($event)"

      >
      </mat-paginator>

      <app-params-form [size]="size" (nextSize)="nextSize($event)"></app-params-form>
      -->
    </div>
    <div class="col-2">&nbsp;</div>
  </div>
  <div class="row">
    <div class="col-2">&nbsp;</div>
    <div class="col-8">
      <bd2-num-heatmap [data]="data" [asymmetric]="false" [middleZero]="middleZero" class="customized">
      </bd2-num-heatmap>

    </div>
    <div class="col-2">&nbsp;</div>
  </div>
</div>


